import config from '@/config'

export async function getOfferConfig (offerId) {
  await window.remoteConfig.fetchAndActivate()
  const configuration = JSON.parse(window.remoteConfig.getString(config.environment))
  return configuration[offerId]
}
